import { useEffect } from 'react';

export default function SEOHead() {
  useEffect(() => {
    // Schema.org JSON-LD structured data
    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '韩漫网站',
        url: 'https://koreanmanhwa.site/',
        description: '韩国漫画免费在线阅读平台，提供下拉式韩漫大全和高清无删减韩漫全集。',
        sameAs: ['https://koreanmanhwa.site/'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '韩漫网站',
        url: 'https://koreanmanhwa.site/',
        description: '韩国漫画免费在线阅读平台，下拉式韩漫大全提供高清无删减韩漫全集。',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://koreanmanhwa.site/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '韩漫网站 - 韩国漫画免费在线阅读',
        url: 'https://koreanmanhwa.site/',
        description: '韩漫网站为您提供韩国漫画免费在线阅读体验，下拉式韩漫大全涵盖高清无删减韩漫全集。',
        isPartOf: { '@id': 'https://koreanmanhwa.site/#website' },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://koreanmanhwa.site/',
          },
        ],
      },
    ];

    // Remove existing JSON-LD scripts
    document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
      if (el.getAttribute('data-seo') === 'dynamic') el.remove();
    });

    // Add new JSON-LD scripts
    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo', 'dynamic');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      document.querySelectorAll('script[type="application/ld+json"][data-seo="dynamic"]').forEach((el) => el.remove());
    };
  }, []);

  return null;
}